import { useEffect, useState } from 'react';
import QR from 'qrcode';

/**
 * Renders a QR code as a data-URL <img>. Async generation, no flash.
 */
export function QRCode({ value, size = 160, className }: { value: string; size?: number; className?: string }) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    QR.toDataURL(value, { margin: 1, width: size, errorCorrectionLevel: 'M' })
      .then(d => { if (!cancelled) setDataUrl(d); })
      .catch(() => { if (!cancelled) setDataUrl(null); });
    return () => { cancelled = true; };
  }, [value, size]);
  if (!dataUrl) return <div style={{ width: size, height: size }} className={`bg-gray-100 rounded ${className || ''}`} aria-label="QR code loading" />;
  return <img src={dataUrl} alt={`QR code for ${value}`} width={size} height={size} className={className} />;
}
